// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Vehicle } from '@interfaces/vehicle.interfaces';
import { getImage, showMissingImage } from 'src/app/utils/utils';

@Component({
    selector: 'app-vehicle',
    templateUrl: './vehicle.component.html',
    styleUrls: ['./vehicle.component.scss'],
})
export class VehicleComponent implements OnInit {
    @Input() vehicle: Vehicle;
    @Input() condensed = false;
    @Input() selected = false;

    @Output() selected$ = new EventEmitter();

    public vehicleImage: string | null = null;

    ngOnInit() {
        this.getVehicleImage();
    }

    async getVehicleImage() {
        await getImage(this.vehicle).then((image) => {
            this.vehicleImage = image;
            // Update the vehicle object with the first working image (This will be used by the api to apply a single vehicle image to the deal)
            this.vehicle = { ...this.vehicle, vehicleExt: { ...this.vehicle.vehicleExt, images: this.vehicleImage } };
        });
    }

    public showMissingImage($event: any): void {
        showMissingImage($event);
    }

    vehicleSelected(vehicle: Vehicle) {
        this.selected$.emit(vehicle);
    }
}
